import { render, staticRenderFns } from "./retailTreasures.vue?vue&type=template&id=20576ec9&scoped=true&"
import script from "./retailTreasures.vue?vue&type=script&lang=js&"
export * from "./retailTreasures.vue?vue&type=script&lang=js&"
import style0 from "./retailTreasures.vue?vue&type=style&index=0&id=20576ec9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20576ec9",
  null
  
)

export default component.exports